module.exports = __webpack_public_path__ + "img/count-03.b560c850.png";